<script setup>

import {computed} from "vue";

const props = defineProps({
  color: {
    type: String,
    default: '#5A3E38'
  },
  active:{
    type: null,
    default: false
  },
});
const emit = defineEmits(['update:active', 'change']);
const getColor = computed(() => {
  return  props.color === 'primary' ? "#887C77" : props.color;
})

function handler() {
  let val = !props.active;

  emit('change', val)
  emit('update:active', val)
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    class="heart select-none"
    :class="{'animate': props.active}"
    @click="()=>{handler()}"
  >
    <path
      d="M12 8.01798C10 3.32355 3 3.82355 3 9.82358C3 15.8236 12 20.8236 12 20.8236C12 20.8236 21 15.8236 21 9.82358C21 3.82355 14 3.32355 12 8.01798Z"
      :fill="props.active ? getColor : 'none'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.89025 6.99379C4.37574 7.60543 4 8.52364 4 9.8236C4 12.3568 5.93835 14.8475 8.16436 16.8262C9.2453 17.787 10.3309 18.5715 11.1484 19.1165C11.4863 19.3418 11.7768 19.525 12 19.6618C12.2232 19.525 12.5137 19.3418 12.8516 19.1165C13.6691 18.5715 14.7547 17.787 15.8356 16.8262C18.0616 14.8475 20 12.3568 20 9.8236C20 8.52364 19.6243 7.60543 19.1098 6.99379C18.5924 6.37874 17.8836 6.01202 17.1074 5.90016C15.5454 5.67508 13.7381 6.48978 12.92 8.40996C12.7629 8.7787 12.4008 9.01801 12 9.01801C11.5992 9.01801 11.2371 8.7787 11.08 8.40996C10.2619 6.48978 8.4546 5.67508 6.89263 5.90016C6.11636 6.01202 5.40763 6.37874 4.89025 6.99379ZM12 20.8236C11.5144 21.6977 11.5141 21.6976 11.5138 21.6974L11.5131 21.697L11.511 21.6959L11.5043 21.6921L11.4814 21.6792C11.4692 21.6723 11.4537 21.6635 11.4351 21.6528C11.4241 21.6465 11.4119 21.6395 11.3987 21.6318C11.3276 21.5908 11.2255 21.531 11.0968 21.4533C10.8395 21.2981 10.475 21.0713 10.0391 20.7806C9.16911 20.2007 8.0047 19.3602 6.83564 18.321C4.56165 16.2997 2 13.2904 2 9.8236C2 8.12355 2.49926 6.72925 3.35975 5.70633C4.21737 4.68682 5.38364 4.09694 6.60737 3.9206C8.53723 3.64251 10.6266 4.38814 12 6.08702C13.3734 4.38814 15.4628 3.64251 17.3926 3.9206C18.6164 4.09694 19.7826 4.68682 20.6402 5.70633C21.5007 6.72925 22 8.12355 22 9.8236C22 13.2904 19.4384 16.2997 17.1644 18.321C15.9953 19.3602 14.8309 20.2007 13.9609 20.7806C13.525 21.0713 13.1606 21.2981 12.9032 21.4533C12.7745 21.531 12.6724 21.5908 12.6013 21.6318C12.5658 21.6524 12.5381 21.6682 12.5186 21.6792L12.4957 21.6921L12.489 21.6959L12.4869 21.697L12.4862 21.6974C12.4859 21.6976 12.4856 21.6977 12 20.8236ZM12 20.8236L12.4856 21.6977C12.1836 21.8655 11.8164 21.8655 11.5144 21.6977L12 20.8236Z"
      :fill="getColor"
    />
  </svg>
</template>

<style scoped>
.heart {
  cursor: pointer;
  transition: transform 0.3s, opacity 0.4s;
}

.heart:active {
  transform: scale(0.8);
}

.heart.animate {
  animation: heartBeat 0.4s forwards;
}

@keyframes heartBeat {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
